export const container = {
    hidden: {opacity:1,
    },
    show: {
        opacity:1,
        transition: {
            staggerChildren: 0.2,
        }
    },

}

export const item = {
    hidden: {x:-100, opacity: 0},
    show: {x:0, opacity:1},

}
